import React, { useRef, useContext } from 'react';
import { context } from '../../../../context';
import { StatusStyled } from './Styled';
import { Title, Paragraph, Margin, Button } from '../..';
import { IContextData } from '../types';

const Success = () => {
  const { history, urlData, dispatchMetrics, brand } = useContext<IContextData>(context);
  const redirectToHome = () => history.push('/');

  const divRef = useRef<HTMLDivElement>(null);
  const App = urlData?.app;
  dispatchMetrics('Page:load', {
    Pagetype: 'Avaliacao',
    Pagename: `${brand}:Avaliacao:Avaliação-Sucesso`,
  });
  const buttonWeb = App ? null : (
    <>
      <Button onClick={redirectToHome} variant="secondary">
        ir para a página inicial
      </Button>
    </>
  );
  React.useEffect(() => {
    divRef?.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <div ref={divRef}>
      <StatusStyled>
        <Title color="#07AA07">sua avaliação foi enviada :)</Title>
        <Margin bottom={16} />
        <Paragraph>Ela vai ser analisada e em breve publicada na página do produto, tá?</Paragraph>
        <Margin bottom={32} />
        {buttonWeb}
      </StatusStyled>
    </div>
  );
};

export default Success;
export { Success };
